var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChickenLeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4736 5.35224C7.80047 4.99622 8 4.52141 8 4C8 2.89543 7.10457 2 6 2C4.89543 2 4 2.89543 4 4C2.89543 4 2 4.89543 2 6C2 7.10457 2.89543 8 4 8C4.52143 8 4.99626 7.80045 5.35228 7.47356L8.26064 10.3819C7.18491 13.3753 9.65493 18.0715 11.7291 20.1457C14.1394 22.5559 17.9774 22.6257 20.3015 20.3015C22.6257 17.9774 22.5559 14.1394 20.1457 11.7291C18.0715 9.65494 13.3754 7.18494 10.382 8.26061L7.4736 5.35224Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenLeg);
export default __webpack_public_path__ + "static/media/chicken-leg.70d8d46a93cd1dd360ecd314d9b33b37.svg";
export { ForwardRef as ReactComponent };